"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CheckBoxInput = _interopRequireDefault(require("../../../../atoms/CheckBoxInput/index.js"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
const GaugeCardCheckbox = props => {
  const {
    item,
    handleChecked,
    isChecked
  } = props;
  const handleCheckbox = (value, checkStatus) => {
    handleChecked(value, checkStatus);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBoxInput.default, {
    name: item?.title,
    label: item?.title,
    value: item?.title,
    idx: item?.value,
    onCheckedChange: (value, checkStatus) => {
      handleCheckbox(value, checkStatus);
    },
    checked: isChecked
  });
};
var _default = exports.default = GaugeCardCheckbox;
module.exports = exports.default;
module.exports.default = exports.default;